/**
 * Vrací textovou hodnotu atributu z elementu práv. Pokud atributu neexistuje vrací `undefined`.
 * @param e Element ve kterém se má hledat atribut práv
 * @param key Název hledaného atributu
 */
export const parseRightElementAttribute = <TKey extends string>(e: Element, key: TKey): string | undefined => {
    if (!e?.attributes?.getNamedItem(key))
        return undefined;
    else
        return e.attributes.getNamedItem(key)!.value;
};

/**
 * Vrací textovou hodnotu atributu z elementu práv. Pokud atributu neexistuje vyhazuje výjimku.
 * @param e Element ve kterém se má hledat atribut práv
 * @param key Název hledaného atributu
 */
export const parseRequiredRightElementAttribute = <TKey extends string>(e: Element, key: TKey): string => {
    const attrValue = parseRightElementAttribute(e, key);
    if (attrValue === undefined)
        throw new Error("Cannot create instance of ItemRights. Some required attributes are missing");
    return attrValue;
};
